module.exports = __webpack_public_path__ + "static/skyping-animation-96bcb2fec62e885d194117faec5a8e62.svg";